import { components, paths } from "@api/api";
import { ID } from "@datassential/platform-ui-lib";
import useAxios from "@hooks/useFetch";
import { useMemo } from "react";

const CONSUMER_GROUPS_ENDPOINT: keyof paths = '/api/Item/GetConsumerGroupsData';

export type ProfileConsumerGroupsRequest = components["schemas"]["FlavorTracker.Entities.DTO.ItemPage.ItemConsumerGroupsRequest"];
export type ProfileConsumerGroupsResponse = components["schemas"]["FlavorTracker.Entities.DTO.ItemPage.ItemConsumerGroups"];

export function useProfileConsumerGroups(
    id: ID,
    categoryId: ID,
): {
    isLoading: boolean;
    data: ProfileConsumerGroupsResponse;
} {
    const payload = useMemo(() => ({
        id,
        categoryId,
    }), [id, categoryId]);
    
    const response = useAxios<ProfileConsumerGroupsResponse>({
        url: CONSUMER_GROUPS_ENDPOINT,
        method: 'post',
        payload,
    });

    return {
        ...response,
        data: response.data ?? {},
    };
}